import {useState, useEffect} from "react";

export function useDelayedValue<T>(value: T, delayMs: number): T {
    const [delayed, setDelayed] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setDelayed(value), delayMs);
        return () => clearTimeout(timer);
    }, [value, delayMs]);

    return delayed;
}
